export default "__VITE_ASSET__C0qd_k0d__"